import { render, staticRenderFns } from "./dataTree.vue?vue&type=template&id=221543ac&scoped=true&"
import script from "./dataTree.vue?vue&type=script&lang=js&"
export * from "./dataTree.vue?vue&type=script&lang=js&"
import style0 from "./dataTree.vue?vue&type=style&index=0&id=221543ac&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "221543ac",
  null
  
)

export default component.exports